<template>

    <div class="container">

        <div class="row">

            <div class="col-12">

                <div class="edit-map-mode">

                    <MglMap
                        :ref="'edit-map-mode'"
                        :mapboxGl="mapboxgl"
                        :mapStyle.sync="mapBoxSettings.mapStyle"
                        :accessToken="mapBoxSettings.accessToken"
                        @load="onMapLoaded"
                        :center="[ parseFloat( dataStore.activeMapObj.centerLng ), parseFloat( dataStore.activeMapObj.centerLat ) ]"
                        :zoom="parseFloat( currentZoomOther )"
                        :maxZoom="18"
                    >
                        <MglNavigationControl position="bottom-right"/>

                    </MglMap>

                </div>

            </div>

            <div v-if="editable" class="col-12 allow-image-upload">
                <div class="form-check">
                    <input type="checkbox" class="allow-image-upload form-check-input" v-model="dataStore.allowUploadImage" id="allow-image-upload-map">
                    <label class="form-check-label" for="allow-image-upload-map">{{ language.add_type_allow_image }}</label>
                </div>
            </div>

            <div v-if="editable" class="col-12 map-search">

                <div class="form-check map-search">
                    <input type="checkbox" v-model="dataStore.mapSearch" class="form-check-input" id="map-search">
                    <label class="form-check-label" for="spam-protection">{{ language.add_type_map_search }}</label>
                </div>

            </div>

            <div v-if="dataStore.questionType === 'goodbad' && editable" class="col-12 limit-markers">
                <div class="form-check">
                    <input type="checkbox" class="allow-image-upload form-check-input" v-model="dataStore.allowLimitMarkers" id="limit-markers">
                    <label class="form-check-label" for="limit-markers">{{ language.add_type_limit_markers }}</label>
                </div>
            </div>

            <div v-if="editable && dataStore.allowLimitMarkers" class="col-12 range-control">
                <input type="range" min="1" max="20" v-model="dataStore.amountAnswers" class="control" id="amount-answers">
                <label for="amount-answers">{{ language.add_type_limit_amount.replacePlaceholders({ number : dataStore.amountAnswers }) }}</label>
            </div>

            <label v-if="editable" class="media-label qualites map-qualites">{{ language.add_type_qualities }}</label>

            <div v-if="editable" class="checkbox-multi map-multi-checkbox form-group">
                <label for="add-good-options"><input v-if="editable" type="checkbox" v-model="dataStore.allowGoodOptions" class="form-check-input" id="allow-good-options"> {{ language.add_type_good }}</label>
                <label for="add-bad-options"><input v-if="editable" type="checkbox" v-model="dataStore.allowBadOptions" class="form-check-input" id="allow-bad-options"> {{ language.add_type_bad }}</label>
            </div>

            <div v-if="editable && dataStore.questionType === 'goodbad'" class="col-12">
                
                <div class="row">

                    <div class="col-12 col-lg-6">

                        <div class="custom-hint form-group">
                            <label for="custom-hint" class="media-label">{{ language.add_type_hint_map }}</label>
                            <input type="text" v-model="dataStore.hint" class="form-control" id="custom-hint" />
                        </div>
                        
                    </div>

                </div>
                
            </div>

            <response-form-description v-if="editable && dataStore.questionType === 'goodbad'" v-model="dataStore.responseFormDescription" :type="'map'" :custom-label="language.text_response_box"></response-form-description>

            <div class="col-12 save-buttons" v-if="editable">

                <div class="row">

                    <div class="col-12 last">

                        <div class="form-group map save-buttons">
                            <button class="btn btn-primary" :disabled="dataStore.activeMapObj.paths.length ? false : true" v-on:click.prevent="addOrEditMap($event)">{{ language.add_type_save }}</button>
                            <button class="btn btn-primary" :disabled="dataStore.activeMapObj.paths.length || isDrawing ? true : false" v-on:click.prevent="createPathsBasedOnCenter">{{ language.add_type_drawing }}</button>
                            <button class="btn btn-primary last-btn-map" :disabled="dataStore.activeMapObj.paths.length || isDrawing ? false : true" v-on:click.prevent="resetPaths">{{ language.add_type_clear }}</button>
                            <a class="cancel" href="#" v-on:click.prevent="globalFunctions.toggleAddMedia">{{ language.add_type_cancel }}</a>
                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>

</template>

<script>

import dataStore from '../../store'

import globalFunctions from '../../globalFunctions'

import mapboxgl from 'mapbox-gl'

import L from 'leaflet'

import { MglMap, MglNavigationControl } from 'vue-mapbox'

import MapboxDraw from "@mapbox/mapbox-gl-draw";

import mapBoxSettings from './../../../mapbox-settings'



import ResponseFormDescription from '../common/ResponseFormDescription.vue'


export default {

    components: {

        MglMap,

        MglNavigationControl,

        ResponseFormDescription

    },

    data() {

        return {

            mapboxgl,

            mapBoxSettings,

            dataStore,

            globalFunctions,

            currentTab : 1,

            currentZoom : 3,

            currentZoomOther: 3,

            errors : [],

            limitMap : 0.1,

            mapbox : null,

            map : null,

            draw : null,

            isDrawing : false,

            allowToAdjust : true

        }

    },

    computed: {
        editable: function() {
            return this.superadmin ? true : ( this.dataStore.project.allowToEdit && this.dataStore.isLoaded )
        }
    },

    inject: [ 'language', 'superadmin' ],

    methods: {

        onMapLoaded: function(event) {

            this.mapbox = event.component.mapbox

            this.map = event.map

            this.map.on('zoomend', () => this.zoom_changed() )

            this.map.on('dragend', () => this.dragend() );

            this.map.on('draw.create', this.createOrUpdatePolygon);

            this.map.on('draw.update', this.createOrUpdatePolygon);

            this.map.on('idle', () => {

                if( this.dataStore.editMode && this.allowToAdjust ) {

                    if( this.dataStore.activeMapObj.paths.length ) {

                        const fit = L.polygon(this.dataStore.activeMapObj.paths[0]).getBounds()

                        const southWest = [fit['_southWest']['lat'], fit['_southWest']['lng']]

                        const northEast = [fit['_northEast']['lat'], fit['_northEast']['lng']]

                        this.map.fitBounds( [ southWest , northEast ], { padding: 16, duration: 0 } )

                        this.allowToAdjust = false

                    }

                }

            })

            if( this.dataStore.activeMapObj.paths.length ) {

                this.createDrawTool()

            }

        },

        addPolygon: function() {

            if( ! this.dataStore.activeMapObj.paths.length ) return

            this.draw.add({

                geometry : {
                    coordinates : this.dataStore.activeMapObj.paths,
                    type : 'Polygon'
                },

                type : 'Feature'

            } )

        },

        createOrUpdatePolygon: function(e) {

            const data = this.draw.getAll()

            if( data.features.length ) {

                const coordinates = data.features[0].geometry.coordinates

                this.dataStore.activeMapObj.paths = coordinates

            }

        },

        resetDraw: function() {

            this.draw.deleteAll()

            this.map.removeControl(this.draw)

            this.draw = null

            this.isDrawing = false

        },

        createDrawTool: function() {

            const mode = this.dataStore.activeMapObj.paths.length ? 'simple_select' : 'draw_polygon'

            this.draw = new MapboxDraw({

                displayControlsDefault: false,

                controls: {
                    polygon: false,
                    trash: false
                },

                defaultMode: mode

            })

            this.map.addControl(this.draw, 'top-left')

            this.isDrawing = true;

            this.addPolygon()

        },

        resetPaths: function() {

            this.dataStore.activeMapObj.paths = []

            this.resetDraw()
        },

        createPathsBasedOnCenter : function() {

            if(this.dataStore.activeMapObj.paths.length > 0 ) return

            // const centerLat = this.dataStore.activeMapObj.centerLat;

            // const centerLng = this.dataStore.activeMapObj.centerLng;

            // const variableParamCalculate = this.setPolygonCalculateVariable()

            // const ne = [ parseFloat(centerLng + variableParamCalculate), parseFloat(centerLat + variableParamCalculate) ]
            // const sw = [ parseFloat(centerLng - variableParamCalculate), parseFloat(centerLat - variableParamCalculate) ]
            // const nw = [ parseFloat(centerLng + variableParamCalculate), parseFloat(centerLat - variableParamCalculate) ]

            // this.dataStore.activeMapObj.paths = [
            //     [ ne, sw, nw, ne ]
            // ];

            this.createDrawTool()

        },

        mapPathsItem: function() {

            if( this.dataStore.activeMapObj.paths.length ) {

                let paths = this.dataStore.activeMapObj.paths.map(val => ( [parseFloat(val[0]), parseFloat(val[1]) ] ))

                paths.push(paths[0])

                paths = [ paths ];

                return paths
            }

            return []
        },

        addOrEditMap: function(event) {

            const paths = this.mapPathsItem()

            if( ! paths.length) return

            event.target.disabled = false

            const bounds = L.polygon(this.dataStore.activeMapObj.paths[0]).getBounds();

            const center = bounds.getCenter()

            let mapObject

            if( this.dataStore.editMode ) {

                this.globalFunctions.toggleAddMedia(this.dataStore.questionType, true)

                let tempObj = this.dataStore.projectItems[this.dataStore.activeIndex]

                mapObject = this.dataStore.activeMapObj

                if( tempObj.hasOwnProperty('id') ) {
                    mapObject = Object.assign({ id : tempObj.id, updated : true, question : tempObj.question }, mapObject)
                }

            } else {
                mapObject = { created : true }
            }

            // let mapBounds = this.map.getBounds()

            const equalValues = {
                activeType : this.dataStore.activeType,
                questionType : this.dataStore.questionType,
                // restrictionN : mapBounds._ne.lat,
                // restrictionE : mapBounds._ne.lng,
                // restrictionS : mapBounds._sw.lat,
                // restrictionW : mapBounds._sw.lng,
                centerLat: center['lng'],
                centerLng : center['lat'],
                paths : this.dataStore.activeMapObj.paths,
                mapSearch : this.dataStore.mapSearch,
                allowUploadImage : this.dataStore.allowUploadImage,
                allowLimitMarkers : this.dataStore.allowLimitMarkers,
                amountAnswers : this.dataStore.amountAnswers,
                allowGoodOptions : this.dataStore.allowGoodOptions,
                allowBadOptions : this.dataStore.allowBadOptions,
                hint : this.dataStore.hint,
                responseFormDescription : this.dataStore.responseFormDescription
            }

            mapObject = Object.assign(mapObject, equalValues)

            if(this.dataStore.editMode) {
                this.dataStore.projectItems.splice( this.dataStore.activeIndex, 1, mapObject )

            } else {
                this.globalFunctions.toggleAddMedia()
                this.dataStore.projectItems.push(mapObject)
            }

            event.target.disabled = false
        },

        zoom_changed: function() {

            this.currentZoomOther = this.map.getZoom()

            this.currentZoom = this.currentZoomOther;

            const center = this.map.getCenter()

            this.dataStore.activeMapObj.centerLat = center.lat

            this.dataStore.activeMapObj.centerLng = center.lng

        },

        dragend: function() {

            const center = this.map.getCenter()

            this.dataStore.activeMapObj.centerLat = center.lat

            this.dataStore.activeMapObj.centerLng = center.lng

        },

        updateEditedPolygon(mvcArray) {

            let paths = [];

            for (let i = 0; i < mvcArray.getLength(); i++) {

              let path = [];

              for (let j = 0; j < mvcArray.getAt(i).getLength(); j++) {
                let point = mvcArray.getAt(i).getAt(j);
                path.push({lat: point.lat(), lng: point.lng()});
              }

              paths.push(path);

            }

            this.dataStore.activeMapObj.paths = paths;
        },

        // setPolygonCalculateVariable: function() {

        //     const calculateVariable = Math.round( this.currentZoom )

        //     if(calculateVariable == 0) {
        //         return 2;
        //     }

        //     if(calculateVariable >= 1 && calculateVariable <= 5) {
        //         return 1.5
        //     }

        //     if(calculateVariable === 6) {
        //         return 0.5
        //     }

        //     if(calculateVariable === 7) {
        //         return 0.4
        //     }

        //     if(calculateVariable === 8) {
        //         return 0.35
        //     }

        //     if(calculateVariable === 9) {
        //         return 0.15
        //     }

        //     if(calculateVariable === 10) {
        //         return 0.1
        //     }

        //     if(calculateVariable === 11) {
        //         return 0.05
        //     }

        //     if(calculateVariable === 12) {
        //         return 0.02
        //     }

        //     if(calculateVariable === 13) {
        //         return 0.01
        //     }

        //     if(calculateVariable === 14) {
        //         return 0.003
        //     }

        //     if(calculateVariable === 15) {
        //         return 0.002
        //     }

        //     if(calculateVariable === 16) {
        //         return 0.001
        //     }

        //     if(calculateVariable === 17) {
        //         return 0.0005
        //     }

        //     if(calculateVariable === 18) {
        //         return 0.0002
        //     }

        //     if(calculateVariable === 19) {
        //         return 0.0001
        //     }

        //     if(calculateVariable === 20) {
        //         return 0.00005
        //     }

        //     if(calculateVariable === 21) {
        //         return 0.000002
        //     }

        //     if(calculateVariable === 22) {
        //         return 0.000001
        //     }


        // },


        // test from chatGPT

        calculatePoint: function(centerLat, centerLng, distance, bearing) {
            const earthRadius = 6371000; // Earth's radius in meters
            const angularDistance = distance / earthRadius;
            const lat1 = (centerLat * Math.PI) / 180;
            const lon1 = (centerLng * Math.PI) / 180;
            const angularBearing = (bearing * Math.PI) / 180;

            const lat2 = Math.asin(
                Math.sin(lat1) * Math.cos(angularDistance) +
                    Math.cos(lat1) *
                        Math.sin(angularDistance) *
                        Math.cos(angularBearing),
            );

            const lon2 =
                lon1 +
                Math.atan2(
                    Math.sin(angularBearing) *
                        Math.sin(angularDistance) *
                        Math.cos(lat1),
                    Math.cos(angularDistance) - Math.sin(lat1) * Math.sin(lat2),
                );

            return [ ( (lon2 * 180) / Math.PI ), ( (lat2 * 180) / Math.PI ) ]
        },

        // Function to generate a polygon with 4 coordinates based on a center point
        generatePolygon: function(centerLat, centerLng, distanceInMeters) {
            const coordinates = [];
            const numPoints = 4;

            for (let i = 0; i < numPoints; i++) {
                const angle = (i * 360) / numPoints; // Calculate angles for evenly spaced points
                const point = this.calculatePoint(
                    centerLat,
                    centerLng,
                    distanceInMeters,
                    angle,
                );
                coordinates.push(point);
            }

            // Add the first point again to close the polygon
            coordinates.push(coordinates[0]);

            return coordinates;
        },



        // helper functions

        getCenterOfPolygon: function(paths) {

            const maxLat = paths[0].reduce(function(prev, current) {
                return (prev[1] > current[1]) ? prev : current
            })

            const lowestLat = paths[0].reduce(function(prev, current) {
                return (prev[1] < current[1]) ? prev : current
            })

            const maxLng = paths[0].reduce(function(prev, current) {
                return (prev[0] > current[0]) ? prev : current
            })

            const lowestLng = paths[0].reduce(function(prev, current) {
                return (prev[0] < current[0]) ? prev : current
            })

            return [
                parseFloat(lowestLng[0] + (( maxLng[0] - lowestLng[0] ) / 2)),
                parseFloat(lowestLat[1] + (( maxLat[1] - lowestLat[1] ) / 2))
            ]

        },

        // lng = liten = 0
        // lat = stor =  1

        getNorthEast: function(paths) {

            const maxLat = paths[0].reduce(function(prev, current) {
                return (prev[1] > current[1]) ? prev : current
            })

            const maxLng = paths[0].reduce(function(prev, current) {
                return (prev[0] > current[0]) ? prev : current
            })

            return [
                parseFloat( maxLng[0] + this.limitMap ),
                parseFloat( maxLat[1] + this.limitMap )
            ]

        },

        // lng = liten = 0
        // lat = stor =  1

        getSouthWest: function(paths) {

            const lowestLat = paths[0].reduce(function(prev, current) {
                return (prev[1] < current[1]) ? prev : current
            })

            const lowestLng = paths[0].reduce(function(prev, current) {
                return (prev[0] < current[0]) ? prev : current
            })

            return [
                parseFloat( lowestLng[0] + this.limitMap ),
                parseFloat( lowestLat[1] + this.limitMap )
            ]

        },



    }
}

</script>
